// Components
import { Modal } from "@mantine/core";
import { PractitionerForm } from "./Practitioner.form";

// Types
import type { Practitioner, PractitionerRole } from "@medplum/fhirtypes";

// Interfaces
/**
 * Props for the practitioner modal.
 * @agentic connections
 */
type PractitionerModalProps = {
  opened: boolean;
  onClose: () => void;
  onPractitionerCreated: (
    practitioner: Practitioner,
    practitionerRole: PractitionerRole,
  ) => void;
};

/**
 * Modal wrapper for creating a new practitioner.
 * @agentic connections
 */
export const PractitionerModal = (props: PractitionerModalProps) => {
  const { opened, onClose, onPractitionerCreated } = props;

  return (
    <Modal
      radius="md"
      opened={opened}
      onClose={onClose}
      title="Create New Practitioner"
      size="lg"
    >
      <PractitionerForm
        onPractitionerCreated={onPractitionerCreated}
        onComplete={onClose}
      />
    </Modal>
  );
};
